"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getLogoutUrl = (redirectUri) => {
    return `https://auth.sportnet.online/logout${redirectUri ? `?${new URLSearchParams('redirect_uri=' + redirectUri)}` : ''}`;
};
exports.default = getLogoutUrl;
